import * as React from 'react';

import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';
import { Divider } from '@lightspeed/flame/Divider';
import { Modal, ModalBody, ModalHeader } from '@lightspeed/flame/Modal';

import { createReactRenderer } from 'helpers/react-renderer';

import { RuleOption } from './RuleOption';

const StyledModal = styled(Modal)`
  width: 50%;
  max-width: 580px;
`;

const StyledModalBody = styled(ModalBody)`
  padding: 0;
`;

const DiscountRuleModal: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOnClickDiscountRule = () => {
    window.navigateToContent?.('view', 'discount_rule.views.discount_rule');
  };

  const handleOnClickPriceRule = () => {
    window.navigateToContent?.('view', 'price_rule.views.price_rule', undefined, 'details');
  };

  const handleOnCloseModal = () => {
    setIsOpen(false);
  };

  React.useEffect(() => {
    const newPriceRuleButton = document.getElementById('newPriceRuleButton'); // gui-defs

    const handleClickNewPriceButton = () => {
      setIsOpen(true);
    };

    if (!newPriceRuleButton) {
      return () => {};
    }

    newPriceRuleButton.addEventListener('click', handleClickNewPriceButton);

    return () => {
      newPriceRuleButton.removeEventListener('click', handleClickNewPriceButton);
    };
  }, []);

  if (!window.lsCloud.Modules.hasModule('settings.price_rules.advanced_discounts')) {
    return null;
  }

  return (
    <StyledModal isOpen={isOpen} onRequestClose={handleOnCloseModal}>
      <ModalHeader>New discount or price rule</ModalHeader>
      <StyledModalBody data-test="discount-price-rule-modal-body">
        <Flex flexDirection="column">
          <RuleOption
            data-test="discount-rule-button"
            id="modalCreateDiscountRuleButton"
            onClick={handleOnClickDiscountRule}
            text="Set a rule so that your discount is automatically applied at checkout."
            title="Discount rule"
          />
          <Divider />
          <RuleOption
            data-test="price-rule-button"
            id="modalCreatePriceRuleButton"
            onClick={handleOnClickPriceRule}
            text="Set a rule so that your pricing level, margin or markup is automatically applied at checkout."
            title="Price rule"
          />
        </Flex>
      </StyledModalBody>
    </StyledModal>
  );
};

const RenderedComponent = createReactRenderer({
  component: DiscountRuleModal,
  selector: '[data-react-root="ReactModal"]',
});

window.history.onChangeState(
  {
    name: 'price_rule.listings.price_rules',
  },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default DiscountRuleModal;
